var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.display)?_c('apexchart',{staticClass:"mr-1",attrs:{"type":"line","width":_vm.width,"height":_vm.height,"options":_vm.chartOptions,"series":_vm.series}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }